import { Component, OnInit } from '@angular/core';
import { QuestionComponent } from "../question/question.component";
import { QuestionSetLabel } from "../../shared/models/question-set-label";
import { MultipleChoiceQuestion } from 'app/shared/models/multiple-choice-question';

@Component({
  selector: 'app-question-dropdown',
  templateUrl: './question-dropdown.component.html',
  styleUrls: ['./question-dropdown.component.css']
})
export class QuestionDropdownComponent extends QuestionComponent implements OnInit {

  constructor() { 
    super();
  }

  ngOnInit() {
  }

  setAnswer(labelId:string) {
    let answer = this.labels.find((l) => l.id == labelId);
    this.question.setSavedAnswer(labelId, this.labels);
    this.notifyAnswered();
  }

  isSelected(label:QuestionSetLabel) {
    if (!(this.question instanceof MultipleChoiceQuestion)) { 
      return false;
    }
    let mcQuestion = this.question as MultipleChoiceQuestion;
    return mcQuestion.isAnswer(label);
  }

}



// WEBPACK FOOTER //
// ./src/app/assessments/question-dropdown/question-dropdown.component.ts